import z from 'zod';

export enum QuizSessionState {
  ACTIVE = 'ACTIVE',
  ARCHIVE = 'ARCHIVE',
  COMPLETED = 'COMPLETED',
}

export const quizSessionStateSchema = z.nativeEnum(QuizSessionState);
